import { Action } from '@ngrx/store';

export const EDIT_TXT_ACTION = 'EDIT_TXT_ACTION';

export class EditTextActions implements Action {
  readonly type = EDIT_TXT_ACTION;
  constructor(public payload: any) {}
}
